import React from 'react';
import './style.scss';
import CloseIcon from '../../../common/icons/close-slim.svg';
import ArrowDownIcon from '../../../common/icons/arrow-down-slim.svg';
import ArrowUpIcon from '../../../common/icons/arrow-up-slim.svg';

export default function Header(props) {
    const { title, events } = props;
    return (
        <div className="header">
            <div className="table">
                <div className="table-row">
                    <div className="table-cell title">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: title
                            }}
                        />
                    </div>
                    {events.minimize ? (
                        <div className="table-cell minimize">
                            <span
                                title="Minimalizuj"
                                onClick={events.minimize}
                                className="icon icon-down"
                            >
                                <ArrowDownIcon />
                            </span>
                        </div>
                    ) : events.maximize ? (
                        <div className="table-cell maximize">
                            <span
                                title="Maksymalizuj"
                                onClick={events.maximize}
                                className="icon icon-up"
                            >
                                <ArrowUpIcon />
                            </span>
                        </div>
                    ) : null}
                    {events.close ? (
                        <div className="table-cell close">
                            <span
                                title="Zamknij"
                                onClick={events.close}
                                className="icon icon-close"
                            >
                                <CloseIcon />
                            </span>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
